import QRCode from 'qrcode';

export interface QrPayload {
  v: 1;
  endpoint: string;
  token: string;
}

export async function renderRegistrationQr(canvas: HTMLCanvasElement, endpoint: string, token: string): Promise<void> {
  const payload: QrPayload = { v: 1, endpoint, token };
  await QRCode.toCanvas(canvas, JSON.stringify(payload), { width: 220, margin: 1 });
}
